import React from "react";
import { Spin, Result } from "antd";
import { Container } from "./Styled";

type UnauthorizedPageProps = {
};

const UnauthorizedPage: React.FunctionComponent<UnauthorizedPageProps> = (props: UnauthorizedPageProps) => {
  return (
    <Container>
      <Result
        status="error"
        title="Accès non authorisé"
        subTitle="Vous n'avez pas les autorisations nécéssaires pour accéder à cette application"
      >
      </Result>
    </Container>
  );
};

export default UnauthorizedPage; 